module.exports = __webpack_public_path__ + "img/img1.98235251.png";